import styled, { css } from 'styled-components';

export interface Props {
  minWidth?: number | string;
  maxWidth?: number | string;
  minHeight?: number | string;
  maxHeight?: number | string;
  backgroundColor?: 'white' | 'black';
}

export const bonesCSS = css<Props>`
  background: ${({ theme, backgroundColor = 'white' }) =>
    theme.color[backgroundColor]};
  border-radius: ${({ theme }) => theme.x1spacePx / 4}px;
  height: ${({ theme }) => theme.x2spacePx}px;
  opacity: 0.1;
  display: block;
  ${({ minWidth }) => {
    if (typeof minWidth === 'undefined') {
      return;
    }
    if (typeof minWidth === 'string') {
      return css`
        &&& {
          min-width: ${minWidth};
        }
      `;
    }
    return css`
      &&& {
        min-width: ${minWidth}px;
      }
    `;
  }}
  ${({ maxWidth }) => {
    if (typeof maxWidth === 'undefined') {
      return;
    }
    if (typeof maxWidth === 'string') {
      return css`
        &&& {
          max-width: ${maxWidth};
        }
      `;
    }
    return css`
      &&& {
        max-width: ${maxWidth}px;
      }
    `;
  }}
  ${({ maxHeight }) => {
    if (typeof maxHeight === 'undefined') {
      return;
    }
    if (typeof maxHeight === 'string') {
      return css`
        &&& {
          max-height: ${maxHeight};
        }
      `;
    }
    return css`
      &&& {
        max-height: ${maxHeight}px;
      }
    `;
  }}
  ${({ minHeight }) => {
    if (typeof minHeight === 'undefined') {
      return;
    }
    if (typeof minHeight === 'string') {
      return css`
        &&& {
          min-height: ${minHeight};
        }
      `;
    }
    return css`
      &&& {
        min-height: ${minHeight}px;
      }
    `;
  }}
`;

export const Bones = styled('span')<Props>`
  ${bonesCSS}
`;
